import { MDBAlert, MDBBtn, MDBInput, MDBModalBody, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { useEffect, useState } from "react";
import { addPool } from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";

export default function NewPool(props) {


    const [listOrgNames, setListOrgNames] = useState([]);

    const[selOrgId, setSelOrgId] = useState(1);
    const[poolName, setPoolName] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if ((props.orgList?.length ?? 0) > 0) {
            setListOrgNames(props.orgList);
        }
    }, [props]);

    async function addOrgPool(event) {
        try{
            setErrorMessage(null);
            event.preventDefault();
            event.stopPropagation();         
            const POOL_NAME_REGEX = /^.{1,100}$/;
            if (!poolName || poolName.trim() === "") {
                setErrorMessage("The Pool Name cannot be empty.");
                return;
            }     
            if (!POOL_NAME_REGEX.test(poolName)) {
                setErrorMessage("The Pool Name is invalid. It must not exceed a maximum number of 100 characters.");
                return;
            }    
            setIsloading(true);
            //sending add request.
            let apiResponse = await addPool(JSON.parse(sessionStorage.getItem("admin_session")).siteid, poolName, selOrgId);
            setTimeout(() => { setIsloading(false) }, 1000);
            if(apiResponse.status == 200){
                let apiData = await apiResponse.json();
                localStorage.setItem("s_message",apiData.message);
                // window.location.href = "/orggroupslandingpage";
                navigate(".", {
                    state: {
                        tab1: "tab2"
                    }
                })
                window.location.href = "/orggroupslandingpage";
                props.onClose();
            }else if(apiResponse.status == 400){
                let apiErroData = await apiResponse.json();
                setErrorMessage(apiErroData.message?.errors[0]?.message ?? null);
            } else{
                setInternalError(true);
            }
            
        }catch(error){
            console.log(`Unable to add pool :${error}`);
            setInternalError(true);
        }
    }
    return (
        <>
            <MDBModalBody>
                <div class="fw-500">Pool Name</div>
                <div className="w-100 mt-2">
                    <MDBInput maxLength={100} size="sm" onChange={(e)=>{e.stopPropagation();e.preventDefault(); setPoolName(e.target.value); setErrorMessage('');} }  />
                    {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </div>
                <div class="fw-500 mt-3">Org Name</div>
                <div className="w-100 mt-2">
                    <select name="orgId" id="orgId" value={selOrgId} className="form-select" onChange={(e)=>{ e.stopPropagation();e.preventDefault(); setSelOrgId(e.target.value)}}>
                   { listOrgNames.map((orgInfo) =>  (
                        <option value={orgInfo.orgid}>{orgInfo.org_name}</option>
                        ))
                    }
                    </select>
                </div>
            </MDBModalBody>

            <MDBModalFooter>
                <MDBBtn color='secondary' onClick={props.onClose}>
                    Cancel
                </MDBBtn>
                <MDBBtn onClick={(e) => addOrgPool(e)} >Add</MDBBtn>
            </MDBModalFooter>
            {isloading && (
              <>
                  <div className="loadingclass">
                      <MDBBtn disabled>
                          <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                          Loading...
                      </MDBBtn>
                  </div>
              </>
          )}
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="top-center"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
        </>
    );
}